module.exports = __webpack_public_path__ + "img/202113.269f62c5.jpg";